module.exports = __webpack_public_path__ + "img/active-timeline-icon.8003bc6d.svg";